import { render } from "./PageNotFoundView.vue?vue&type=template&id=5ac217ac&scoped=true"
import script from "./PageNotFoundView.vue?vue&type=script&lang=js"
export * from "./PageNotFoundView.vue?vue&type=script&lang=js"

import "./PageNotFoundView.vue?vue&type=style&index=0&id=5ac217ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac217ac"]])

export default __exports__